var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStepIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 71,
    viewBox: "0 0 82 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M46.072 3.15509C40.6125 4.36344 36.0368 7.1232 33.2476 11.3575C30.953 14.8413 29.6115 18.8796 26.3342 21.8325C22.8429 24.978 20.0101 26.625 15.0732 27.1127C-2.92892 28.8918 -2.2112 54.4138 14.63 64.5722C31.4712 74.7305 67.8131 73.3857 78.3021 43.9638C88.7912 14.542 73.4285 6.54184 60.7969 3.36745C56.2 2.21195 50.9065 2.08511 46.072 3.15509Z",
    fill: "#E4C1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0219 17.1875H52.8553C62.6933 17.1875 63.6771 21.7882 64.3426 27.4016L66.9467 49.103C67.7858 56.2211 65.5868 62.037 55.4594 62.037H29.4467C19.2905 62.037 17.0914 56.2211 17.9594 49.103L20.5636 27.4016C21.2002 21.7882 22.184 17.1875 32.0219 17.1875Z",
    fill: "white",
    stroke: "#081E54",
    strokeWidth: 1.71875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8633 21.5291V11.4018C30.8633 7.06149 33.7568 4.16797 38.0971 4.16797H46.7776C51.1179 4.16797 54.0114 7.06149 54.0114 11.4018V21.5291",
    stroke: "#081E54",
    strokeWidth: 1.71875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0005 51.1602L38.7188 51.1602",
    stroke: "#1552E8",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0219 17.1875H52.8553C62.6933 17.1875 63.6771 21.7882 64.3426 27.4016L66.9467 49.103C67.7858 56.2211 65.5868 62.037 55.4594 62.037H29.4467C19.2905 62.037 17.0914 56.2211 17.9594 49.103L20.5636 27.4016C21.2002 21.7882 22.184 17.1875 32.0219 17.1875Z",
    stroke: "#081E54",
    strokeWidth: 1.71875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0011 49.2266L27.5586 49.2266",
    stroke: "#081E54",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.117 34.3407C51.117 35.0352 51.0302 35.7079 50.8566 36.3589C50.6613 37.227 50.314 38.0733 49.8583 38.8112C48.3609 41.3286 45.6048 43.0213 42.4364 43.0213C40.2012 43.0213 38.1829 42.1749 36.6638 40.786C36.0128 40.2217 35.4485 39.549 35.0145 38.8112C34.2116 37.5091 33.7559 35.9683 33.7559 34.3407C33.7559 31.997 34.689 29.8486 36.2081 28.2861C37.7923 26.6585 40.0059 25.6602 42.4364 25.6602C44.9972 25.6602 47.3192 26.767 48.8817 28.5465C50.2706 30.0873 51.117 32.1272 51.117 34.3407Z",
    fill: "#A020FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6779 34.3008H39.2109",
    stroke: "white",
    strokeWidth: 1.5346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4453 31.1289V37.6176",
    stroke: "white",
    strokeWidth: 1.5346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.998,
    cy: 39.1484,
    r: 1.64888,
    stroke: "#081E54",
    strokeWidth: 0.702231
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65.21 8.72733C65.21 8.20127 65.6384 7.77348 66.1673 7.77347L74.3933 7.77344C74.9213 7.77344 75.3496 8.20024 75.3496 8.72729C75.3496 9.25434 74.9213 9.68016 74.3933 9.68016L66.1663 9.68019C65.6384 9.6802 65.209 9.25339 65.209 8.72733L65.21 8.72733Z",
    fill: "#0D318B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2739 12.7881L69.2739 4.59058C69.2739 4.06452 69.7023 3.63672 70.2312 3.63672C70.7602 3.63672 71.1875 4.06352 71.1875 4.59057L71.1875 12.7881C71.1875 13.3142 70.7592 13.742 70.2312 13.742C69.7033 13.742 69.2739 13.3152 69.2739 12.7881Z",
    fill: "#0D318B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0.212675 47.7265C0.212675 47.3668 0.505586 47.0742 0.867297 47.0742L6.49254 47.0742C6.85357 47.0742 7.14648 47.3661 7.14648 47.7265C7.14648 48.0869 6.85357 48.3781 6.49254 48.3781L0.866615 48.3781C0.505586 48.3781 0.211994 48.0863 0.211994 47.7265L0.212675 47.7265Z",
    fill: "#3A6EEC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99027 50.5003L2.99027 44.8945C2.99027 44.5347 3.28318 44.2422 3.64489 44.2422C4.0066 44.2422 4.29883 44.534 4.29883 44.8945L4.29883 50.5003C4.29883 50.86 4.00592 51.1525 3.64489 51.1525C3.28386 51.1525 2.99027 50.8607 2.99027 50.5003Z",
    fill: "#3A6EEC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4806 19.15C72.4806 18.7974 72.7647 18.5117 73.1153 18.5117L78.5743 18.5117C78.9249 18.5117 79.209 18.7974 79.209 19.15C79.209 19.5025 78.9249 19.7882 78.5743 19.7882L73.1153 19.7882C72.7647 19.7882 72.4806 19.5026 72.4806 19.15Z",
    fill: "#3A6EEC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M75.213 21.8932L75.213 16.4039C75.213 16.0513 75.4971 15.7656 75.8477 15.7656C76.1983 15.7656 76.4824 16.0513 76.4824 16.4039L76.4824 21.8932C76.4824 22.2458 76.1983 22.5315 75.8477 22.5315C75.4971 22.5315 75.213 22.2458 75.213 21.8932Z",
    fill: "#3A6EEC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepIcon1);
export default __webpack_public_path__ + "static/media/StepIcon1.7e695798d8e8eb96365873eb64250e4c.svg";
export { ForwardRef as ReactComponent };